var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1874 10.4166H7.8124C7.2374 10.4166 6.77075 10.8823 6.77075 11.4583C6.77075 12.0343 7.2374 12.4999 7.8124 12.4999H17.1874C17.7624 12.4999 18.229 12.0343 18.229 11.4583C18.229 10.8823 17.7624 10.4166 17.1874 10.4166Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1874 15.625H7.8124C7.2374 15.625 6.77075 16.0906 6.77075 16.6667C6.77075 17.2427 7.2374 17.7083 7.8124 17.7083H17.1874C17.7624 17.7083 18.229 17.2427 18.229 16.6667C18.229 16.0906 17.7624 15.625 17.1874 15.625Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2545 3.125H18.1598C17.9045 1.3625 16.3983 0 14.567 0H10.4004C8.56914 0 7.06289 1.3625 6.80767 3.125H5.71289C3.98999 3.125 2.58789 4.5271 2.58789 6.25V21.875C2.58789 23.5979 3.98999 25 5.71289 25H19.2545C20.9774 25 22.3795 23.5979 22.3795 21.875V20.9391C22.3795 20.3638 21.9132 19.8975 21.3379 19.8975C20.7625 19.8975 20.2962 20.3639 20.2962 20.9392L20.2962 21.875C20.2962 22.45 19.8285 22.9167 19.2545 22.9167H5.71284C5.13892 22.9167 4.67119 22.45 4.67119 21.875V6.25C4.67119 5.675 5.13892 5.20835 5.71284 5.20835H7.12012C7.70762 6.43545 8.95137 7.2917 10.4003 7.2917H14.567C16.016 7.2917 17.2597 6.43545 17.8472 5.20835H19.2545C19.8285 5.20835 20.2961 5.675 20.2961 6.25V15.9583C20.2961 16.5336 20.7625 17 21.3378 17C21.9132 17 22.3795 16.5336 22.3795 15.9583V6.25C22.3795 4.5271 20.9774 3.125 19.2545 3.125ZM14.567 2.08335H10.4003C9.53892 2.08335 8.83784 2.78438 8.83784 3.64585C8.83784 4.50732 9.53887 5.20835 10.4003 5.20835H14.567C15.4285 5.20835 16.1295 4.50732 16.1295 3.64585C16.1295 2.78438 15.4285 2.08335 14.567 2.08335Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/Tasks.c6ce59bc4bd9dec12133aff05c5ce298.svg";
export { ForwardRef as ReactComponent };